interface IGetCartOptions {
    immediate?: boolean;
}

export const useCart = (options?: IGetCartOptions) => {
    const cart = useCartStore();
    const pending = ref(true);

    const get = async () => {
        pending.value = true;
        try {
            await cart.get();
        } finally {
            pending.value = false;
        }
    };

    if (options?.immediate) {
        get();
    } else {
        pending.value = false;
    }

    const refresh = async () => {
        pending.value = true;
        try {
            await cart.refresh();
        } finally {
            pending.value = false;
        }
    };

    const update = async (id: number, body: any) => {
        pending.value = true;
        try {
            await cart.update(id, body);
        } finally {
            pending.value = false;
        }
    };

    const remove = async (id: number) => {
        pending.value = true;
        try {
            await cart.remove(id);
        } finally {
            pending.value = false;
        }
    };

    const removeOutOfStocks = async () => {
        pending.value = true;
        try {
            await cart.refresh({
                params: {
                    remove_out_of_stocks: true
                }
            });
        } finally {
            pending.value = false;
        }
    };

    return {
        data: cart,
        pending,
        get,
        refresh,
        remove,
        update,
        removeOutOfStocks
    };
}
